"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _client = require("../types/client");
var _events = require("events");
var _context = _interopRequireDefault(require("./context"));
var _is = require("../utils/is");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Client = /*#__PURE__*/function () {
  function Client() {
    var _this = this;
    this.emitter = new _events.EventEmitter();
    this.collectors = void 0;
    this.processors = void 0;
    this.reporter = void 0;
    this.ctx = void 0;
    this.sendEvent = function (payload) {
      _this.emitter.emit(_client.EventType.collect, payload);
    };
  }
  var _proto = Client.prototype;
  _proto.init = function init(config, rumSession) {
    var _this2 = this;
    this.ctx = new _context["default"](config, rumSession);
    var ctx = this.ctx,
      collectors = this.collectors,
      processors = this.processors,
      reporter = this.reporter;
    processors.forEach(function (processor) {
      (0, _is.isFunction)(processor.setup) && processor.setup(ctx);
    });

    // collector 收集数据统一 push 到各匹配 processor
    this.emitter.on(_client.EventType.collect, function (payload) {
      ctx.setRumEvent(payload);
      for (var _iterator = _createForOfIteratorHelperLoose(processors), _step; !(_step = _iterator()).done;) {
        var processor = _step.value;
        // default match return true
        if (!processor.match) {
          processor.match = function () {
            return true;
          };
        }
        if (processor.match(ctx)) {
          var res = processor.process(ctx);
          if (res) {
            ctx.setRumEvent(res);
          }
        }
      }
      reporter.report(ctx);
    });
    collectors.forEach(function (collector) {
      collector.setup(ctx, _this2.sendEvent);
    });
  };
  _proto.setContext = function setContext(ctx) {
    this.ctx = ctx;
  };
  _proto.getContext = function getContext() {
    return this.ctx;
  };
  _proto.useCollectors = function useCollectors(collectors) {
    this.collectors = collectors;
  };
  _proto.useProcessors = function useProcessors(processors) {
    this.processors = processors;
  };
  _proto.useReporter = function useReporter(reporter) {
    this.reporter = reporter;
  };
  return Client;
}();
var _default = exports["default"] = Client;